<div>
    <div class="close-btn"> <button class="plain-btn" (click)="onClose()">
        <img class="cancle" alt="close" src="/assets/icons/Close.svg" /></button>
    </div>
  <div class="date-range-wrapper">
    <div  class="sidebar" >
      <button
        *ngFor="let range of ranges"
        [class.active]="activeRange === range.label"
        (click)="selectRange(range)"
      >
        {{ range.label }}
      </button>
    </div>
    <ngb-datepicker
      #dp
      (dateSelect)="onDateSelection($event)"
      [startDate]="startDate"
      [displayMonths]="2"
      [dayTemplate]="t"
      outsideDays="hidden"
    ></ngb-datepicker>

    <ng-template #t let-date let-focused="focused">
      <span
        class="custom-day"
        [class.focused]="focused"
        [class.range]="isRange(date)"
        [class.disabled]="isFutureDate(date)"
        [class.faded]="isHovered(date) || isInside(date)"
        (mouseenter)="(hoveredDate = date)"
        (mouseleave)="hoveredDate = null"
      >
        {{ date.day }}
      </span>
    </ng-template>
  </div>
  <div class="footer" >
    <button class="reset-btn" (click)="reset()">Reset</button>    
    <button  class="apply-btn" [disabled]="fromDate ==null || toDate ==null" (click)="apply()">Apply</button>
  </div>
</div>

